import { render, staticRenderFns } from "./TopicClusteringTree.vue?vue&type=template&id=0ad07a20&scoped=true"
import script from "./TopicClusteringTree.vue?vue&type=script&lang=js"
export * from "./TopicClusteringTree.vue?vue&type=script&lang=js"
import style0 from "./TopicClusteringTree.vue?vue&type=style&index=0&id=0ad07a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad07a20",
  null
  
)

export default component.exports